import {HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {isBackendUrl} from './interceptors-helper';

@Injectable()
export class TraceIdInterceptor implements HttpInterceptor {
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (isBackendUrl(req.url)) {
      const traceId = this.generateTraceId();
      const modifiedReq = req.clone({
        headers: req.headers.append('x-b3-traceid', `${traceId}`).append('x-b3-spanid', `${traceId}`)
      });
      return next.handle(modifiedReq);
    } else {
      return next.handle(req);
    }
  }

  /**
   * Generate a unique 16 bit length trace id in hexadecimal format.
   * It is compatible with the X-B3-TraceId from Spring Sleuth at backend.
   */
  generateTraceId(): string {
    return [...Array(16)].map(() => Math.floor(Math.random() * 16).toString(16)).join('');
  }
}
